import {
  Box,
  Grid,
  InputAdornment,
  TextField,
  Tooltip,
  Typography
} from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import ModalConfirm from 'src/app/components/ModalConfirm';
import {
  CustomSwitchWithText,
  FeatureCard,
  SectionTitle
} from '../components/common';
import useStyles from '../styles';
import { FORCE_LIVE_MAX_SECONDS } from '../utils';

export default function CameraConfigSection({
  camera,
  canEdit = false,
  canKeepLive = false,
  canForceLive = false
}) {
  const classes = useStyles();
  const {
    cameraConfig,
    cameraSubmitting,
    isLive4gOn,
    isKeepLiveActive,
    isForceLiveActive,
    isKeepLiveInvalid,
    isForceLiveInvalid,
    updateCameraConfig,
    live4gSubmitting,
    onToggleLive4g,
    live4gConfirmProps,
    keepLiveOffSubmitting,
    onToggleKeepLive,
    keepLiveOffConfirmProps
  } = camera;

  return (
    <Box className={classes.sectionCard}>
      <ModalConfirm {...live4gConfirmProps} />
      <ModalConfirm {...keepLiveOffConfirmProps} />
      <SectionTitle title="Cấu hình Camera" />
      <Grid container spacing={2}>
        <Grid item md={4} sm={6} xs={12}>
          <FeatureCard title="Live & Playback qua 4G">
            <CustomSwitchWithText
              checked={cameraConfig.live4g === 1}
              onChange={canEdit ? onToggleLive4g : undefined}
              name="live4g"
              disabled={!canEdit || cameraSubmitting || live4gSubmitting}
            />
          </FeatureCard>
        </Grid>

        {/* Giữ live sau khi tắt ACC: admin + CSKH + đại lý */}
        {canKeepLive && (
          <Grid item md={4} sm={6} xs={12}>
            <Box className={classes.featureCard}>
              <Box className={classes.featureCardHead}>
                 <Tooltip
                  title={`Thiết bị sẽ tiếp tục duy trì chế độ Live và ghi hình trong khoảng thời gian bạn cài đặt sau khi tắt ACC`}
                >
                  <Typography
                    className={clsx(
                      classes.featureCardTitle,
                      classes.cameraCardTitle
                    )}
                  >
                    Thời gian duy trì Live và ghi hình sau khi tắt khoá (ACC)
                  </Typography>
                </Tooltip>
                <CustomSwitchWithText
                  size="small"
                  checked={isKeepLiveActive}
                  onChange={onToggleKeepLive}
                  disabled={
                    cameraSubmitting || keepLiveOffSubmitting || !isLive4gOn
                  }
                  name="keepLiveEnabled"
                  inputProps={{ 'aria-label': 'edit keep live' }}
                />
              </Box>
              <Box className={classes.cameraInputRow}>
                <TextField
                  className={`input-no-fieldset ${classes.textField} ${classes.strongInput}`}
                  fullWidth
                  size="small"
                  type="number"
                  placeholder="Nhập số giây..."
                  value={cameraConfig.keepLive}
                  disabled={cameraSubmitting || !isKeepLiveActive}
                  onChange={e => updateCameraConfig('keepLive', e.target.value)}
                  error={isKeepLiveInvalid}
                  helperText={
                    isKeepLiveInvalid ? 'Số nguyên, lớn hơn hoặc bằng 0' : ''
                  }
                  variant="outlined"
                  inputProps={{ min: 0, step: 1 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <span className={classes.unitText}>giây</span>
                      </InputAdornment>
                    )
                  }}
                />
              </Box>
            </Box>
          </Grid>
        )}

        {canForceLive && (
          <Grid item md={4} xs={12}>
            <Box className={classes.featureCard}>
              <Box className={classes.featureCardHead}>
                <Tooltip
                  title={`Sau khi tắt ACC, nhấn nút "Xem Live" để xem trực tiếp tối đa ${FORCE_LIVE_MAX_SECONDS} giây (bỏ qua thời gian duy trì ở mục bên). Thiết bị không ghi hình trong thời gian xem Live`}
                >
                  <Typography
                    className={clsx(
                      classes.featureCardTitle,
                      classes.cameraCardTitle
                    )}
                  >
                    Thời gian cho phép xem Live cưỡng bức sau khi tắt khóa (ACC)
                  </Typography>
                </Tooltip>
                <CustomSwitchWithText
                  size="small"
                  checked={isForceLiveActive}
                  onChange={e =>
                    updateCameraConfig('forceLiveEnabled', e.target.checked)
                  }
                  disabled={cameraSubmitting || !isLive4gOn}
                  name="forceLiveEnabled"
                  inputProps={{ 'aria-label': 'edit force live' }}
                />
              </Box>
              <Box className={classes.cameraInputRow}>
                <TextField
                  className={`input-no-fieldset ${classes.textField} ${classes.strongInput}`}
                  fullWidth
                  size="small"
                  type="number"
                  placeholder={`Nhập 1 - ${FORCE_LIVE_MAX_SECONDS} giây...`}
                  value={cameraConfig.forceLive}
                  disabled={cameraSubmitting || !isForceLiveActive}
                  onChange={e =>
                    updateCameraConfig('forceLive', e.target.value)
                  }
                  error={isForceLiveInvalid}
                  helperText={
                    isForceLiveInvalid
                      ? `Từ 1 đến ${FORCE_LIVE_MAX_SECONDS} giây`
                      : ''
                  }
                  variant="outlined"
                  inputProps={{
                    min: 1,
                    max: FORCE_LIVE_MAX_SECONDS,
                    step: 1
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <span className={classes.unitText}>giây</span>
                      </InputAdornment>
                    )
                  }}
                />
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
